import moment from "moment";

export function currency(amount, decimals = 2, commas = true) {
  let amt = amount.toFixed(decimals);
  if (commas) amt = numberWithCommas(amt);
  return `$ ${amt}`;
}

export function percentage(value, decimals = 2) {
  return `${value.toFixed(decimals)} %`;
}

export function accounting(amount) {
  return amount < 0 ? `( ${(-amount).toFixed(2)} )` : `${amount.toFixed(2)}`;
}

export function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function botColor(name) {
  // https://coolors.co/ffbe0b-fb5607-ff006e-8338ec-3a86ff
  switch (name) {
    case "alpha":
      return "#3A86FF";
    case "tess":
      return "lightgrey";
    case "noodles":
      return "darkorange";
    case "larry":
      return "#54fa48";
    case "boris":
      return "#FB5607";
    case "reuben":
      return "#fc95da";
    case "pikachu":
      return "gold";
    case "squirtle":
      return "#a1d9ef";
    default:
      return "black";
  }
}

export function duration(ms) {
  const diff = moment.duration(ms, "millisecond");

  const tenths = Math.floor(diff.milliseconds() / 100);

  if (diff.minutes() === 0) {
    return tenths ? `${diff.seconds()}.${tenths}s` : `${diff.seconds()}s`;
  }

  return `${diff.minutes()}m ${Math.abs(diff.seconds())}s`;
}

export function marketType(type) {
  switch (type) {
    case "FIXED_WIN":
      return "Win";
    case "FIXED_PLACE":
      return "Place";
    case "FIXED_2_PLACE":
      return "Place (2)";
    case "FAV_FIELD":
      return "Fav v Field";
    default:
      return "Unknown";
  }
}

export function raceType(type) {
  switch (type) {
    case "HORSE":
      return "Horses";
    case "HARNESS":
      return "Harness";
    case "GREYHOUND":
      return "Greyhounds";
    default:
      return "Unknown";
  }
}

export function state(state) {
  switch (state) {
    case "ACT":
      return "Australian Capital Territory";
    case "NSW":
      return "New South Wales";
    case "NT":
      return "Northern Territory";
    case "QLD":
      return "Queensland";
    case "SA":
      return "South Australia";
    case "TAS":
      return "Tasmania";
    case "VIC":
      return "Victoria";
    case "WA":
      return "Western Australia";
    default:
      return "Unknown State";
  }
}
